module.exports = __webpack_public_path__ + "static/media/life-loader-navy-blue.206df972.gif";